import { render, staticRenderFns } from "./FileRef.vue?vue&type=template&id=a8c68406&scoped=true&"
import script from "./FileRef.vue?vue&type=script&lang=js&"
export * from "./FileRef.vue?vue&type=script&lang=js&"
import style0 from "./FileRef.vue?vue&type=style&index=0&id=a8c68406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c68406",
  null
  
)

export default component.exports